import { Grid } from "@mui/material";
import { KeyboardArrowRight } from "@mui/icons-material";
import ImageLoader from "../components/ImageLoader";
import CustomText from "../components/CustomText";
import { useNavigate } from "react-router-dom";

const InsuranceCompanies = () => {
  const navigate = useNavigate();

  return (
    <Grid container sx={design.Back}>
      <Grid size={design.Grid1} />
      <Grid container size={design.Grid10}>
        <Grid size={design.Grid12}>
          <CustomText
            variant="subtitle1"
            color="#333333"
            text="Aseguradoras"
            sx={design.Title}
          >
            Aseguradoras
          </CustomText>

          <CustomText
            variant="subtitle1"
            color="#333333"
            text=" Queremos estar cerca de ti"
            sx={design.Description}
          >
            Queremos estar cerca de ti.
            <br />
            Si tienes preguntas o necesitas orientación sobre nuestros
            servicios, escríbenos.
            <br />
            Nuestro equipo te responderá con profesionalismo, empatía y la
            atención que mereces.
            <br />
            Tu tranquilidad es nuestra prioridad.
          </CustomText>
        </Grid>
        {ImgSeguros.map((doc, index) => (
          <Grid key={index} size={design.Grid4} sx={design.Align}>
            <ImageLoader
              src={doc.img}
              alt="nuestros_valores_en_centro-medico_MEDAM"
              width={262}
              height={doc.Height}
            />
          </Grid>
        ))}
        <Grid size={design.Grid12}>
          <CustomText
            variant="subtitle1"
            color="#2349D0"
            text="Conoce todas nuestras"
            sx={design.Conoce}
            onClick={() => navigate("/insuranceCompanies")}
          >
            Conoce todas nuestras aseguradoras y convenios{" "}
            <KeyboardArrowRight sx={design.Margin} />
          </CustomText>
        </Grid>
      </Grid>
      <Grid size={design.Grid1} />
    </Grid>
  );
};
export default InsuranceCompanies;

const design = {
  Title: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 35,
    fontWeight: 600,
    lineHeight: "normal",
    marginTop: 2,
  },
  Description: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 15,
      sm: 15,
      md: 18,
      lg: 18,
    },
    lineHeight: "normal",
    marginTop: "2%",
    textAlign: "center",
    paddingRight: 5,
  },
  Conoce: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    fontFamily: "Plus Jakarta Sans",
    fontSize: 20,
    lineHeight: "normal",
    marginTop: 4,
  },
  Align: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    marginTop: 5,
  },
  Margin: { marginTop: 0.5 },
  Grid1: { xs: 12, md: 2, xl: 2, lg: 2 },
  Grid10: { xs: 12, md: 8, xl: 8, lg: 8 },
  Grid12: { xs: 11, md: 12, xl: 12, lg: 12 },
  Grid4: { xs: 12, md: 4, xl: 4, lg: 4 },
};

const ImgSeguros = [
  {
    img: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_GNP_seguros.png",
    Height: 71,
  },
  {
    img: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_AXA.png",
    Height: 140,
  },
  {
    img: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Seguros_MetLife.png",
    Height: 71,
  },
  {
    img: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_plan_seguro.jpeg",
    Height: 60,
  },
  {
    img: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Allianz.png",
    Height: 140,
  },
  {
    img: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Mapfre.png",
    Height: 150,
  },
];
